import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Tooltip,
} from "recharts";
import { useGetPromotionByIdQuery } from "../../services/promotions";
import { REWARD_CATEGORY, REWARD_TYPE } from "../../constants/enums";
import usePermission from "../../hooks/userAccess";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const dauData = [
  { name: "Mon", users: 120 },
  { name: "Tue", users: 210 },
  { name: "Wed", users: 180 },
  { name: "Thu", users: 300 },
  { name: "Fri", users: 260 },
  { name: "Sat", users: 140 },
  { name: "Sun", users: 170 },
];

const RewardsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: promoRes } = useGetPromotionByIdQuery(
    id ? { id } : ({ id: "" } as any),
    { skip: !id }
  );

  const { isView } = usePermission({
    label: "Rewards & Offers Management",
    page_permission: "isView",
  });

  const [valueTabs, setValueTabs] = useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Rewards & Offers Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>
            Rewards & Offers Management
          </button>{" "}
          - Rewards & Offers Detail
        </p>
      </div>

      {isView && (
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                {/* <Tab label="Redemption Stats" {...a11yProps(1)} /> */}
              </Tabs>
            </Box>
          </div>
        </div>
      )}

      {isView && (
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="gap_p">
              <div className="vew_img v2 no_radius w_100">
                <h6>Banner Image</h6>
                <figure>
                  <img
                    alt="placeholder"
                    src={
                      promoRes?.data?.image || "/static/images/placeholder.png"
                    }
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>Reward Title</h6>
                <p>{promoRes?.data?.title || ""}</p>
              </div>
              <div className="w_33">
                <h6>Reward Type</h6>
                <p>
                  {promoRes?.data?.type === REWARD_TYPE.DISCOUNT
                    ? "Discount"
                    : "Cashback"}
                  :{" "}
                  {promoRes?.data?.type === REWARD_TYPE.DISCOUNT
                    ? promoRes?.data?.discountValue
                      ? `${promoRes?.data?.discountValue}%`
                      : "-"
                    : promoRes?.data?.cashbackValue || ""}
                </p>
              </div>
              <div className="w_33">
                <h6>Loyalty Points Required</h6>
                <p>{promoRes?.data?.loyaltyPoints || "--"}</p>
              </div>
              <div className="w_33">
                <h6>Validity Period</h6>
                <p>
                  {promoRes?.data?.startFrom || ""
                    ? new Date(
                        promoRes?.data?.startFrom || ""
                      ).toLocaleDateString()
                    : "-"}{" "}
                  to{" "}
                  {promoRes?.data?.expireAt || ""
                    ? new Date(
                        promoRes?.data?.expireAt || ""
                      ).toLocaleDateString()
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>CTA Label</h6>
                <p>{promoRes?.data?.ctaLabel || ""}</p>
              </div>
              <div className="w_33">
                <h6>Max Redemption / Voucher Limit per user</h6>
                <p>{promoRes?.data?.maxRedemptions || ""} times</p>
              </div>
              <div className="w_33">
                <h6>Assigned to Category</h6>
                <p>
                  {promoRes?.data?.category === REWARD_CATEGORY.BOOKS
                    ? "Books"
                    : promoRes?.data?.category === REWARD_CATEGORY.STATIONARY
                    ? "Stationary"
                    : "Uniform"}
                </p>
              </div>
              <div className="w_33">
                <h6>Created Date</h6>
                <p>
                  {promoRes?.data?.createdAt
                    ? new Date(
                        promoRes?.data?.createdAt || ""
                      ).toLocaleDateString()
                    : ""}
                </p>
              </div>
              <div className="w_100">
                <h6>Description</h6>
                <p
                  dangerouslySetInnerHTML={{
                    __html: promoRes?.data?.description || "",
                  }}
                ></p>
              </div>
              <div className="w_100">
                <h6>Terms and Conditions</h6>
                <p
                  dangerouslySetInnerHTML={{
                    __html: promoRes?.data?.termsConditions || "",
                  }}
                ></p>
              </div>
            </div>
          </div>
        </CustomTabPanel>
      )}

      {isView && (
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="grid_sc pt_0 gap_m">
            {/* Daily Active Users Chart */}
            <div className="cards table_card">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Redemption Trends</h2>
                </div>
                <div className="right_s">
                  <p>
                    <span>A day</span>
                    <span>A week</span>
                    <span>A month</span>
                    <span>A year</span>
                  </p>
                </div>
              </div>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={dauData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="users" fill="#38B6FF" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </CustomTabPanel>
      )}
    </>
  );
};

export default RewardsDetail;
